import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from 'utils/axios';
import { ACTIONS } from 'utils/constants';
import { fDateTime, getDateTimeValue, validateDates } from 'utils/formatTime';
import { decrypt } from 'utils/crypto';

//
import API from 'restApi';

import { dispatch, store } from '../store';
import { getExamCode } from './Patient';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  exams: { folders: [] },
  analyses: [],
  prescription: true,
  condensed: false,
  toogleGraph: false,
  lineOpenIndex: null,

  navig: {
    nav_position: 0,
    nb_item_per_page: 5,
    total: 0
  },
  filters: {
    prescrFilter: [],
    examFilter: null,
    levyFrom: null,
    levyTo: null,
    levyHourFrom: new Date(2014, 8, 1, 0, 0.5),
    levyHourTo: new Date(2014, 8, 1, 23, 59),
    abnormal: false
  },
};

const slice = createSlice({
  name: 'exam',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET Exams
    getExamsSuccess(state, action) {

      const { exams } = action.payload;
      state.isLoading = false;
      state.exams = exams;
      state.navig = exams.navig;
    },

    //  SORT & FILTER Exams
    sortByExams(state, action) {
      state.sortBy = action.payload;
    },
    //  SORT & FILTER Exams
    paginationExams(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },

    filterExams(state, action) {
      state.filters = action.payload;
    },
    setAnalyses(state, action) {
      state.analyses = action.payload;
    },
    setPrescription(state, action) {
      state.prescription = action.payload;
    },
    setCondensed(state, action) {
      state.condensed = action.payload;
      state.navig.nav_position = 0;
    },

    setToggleGraph(state, action) {
      state.toogleGraph = action.payload;
    },
    setLineOpenIndex(state, action) {
      state.lineOpenIndex = action.payload;
    },
    initFilters(state) {
      state.filters = initialState.filters;
    },
    init(state) {
      state.exams = initialState.exams;
      state.toogleGraph = initialState.toogleGraph;
      state.lineOpenIndex = initialState.lineOpenIndex;
      // state.condensed = initialState.condensed;
      state.prescription = initialState.prescription;
      state.filters = initialState.filters;
      state.navig = initialState.navig;
      state.analyses = initialState.analyses;
      state.error = initialState.error;

    }

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  sortByExams,
  paginationExams,
  filterExams,
  resetExams,
  setAnalyses,
  setPrescription,
  setCondensed,
  setToggleGraph,
  setLineOpenIndex,
  init,
  hasError,
  initFilters

} = slice.actions;

// ----------------------------------------------------------------------

export function getExams({ ipp }) {
  const { exam: { filters, navig, exams, condensed } } = store.getState();
  const { user: { usercode }, profile, allFavoriteActorsSelected, allActorsSelected, actorsSelected } = decrypt(JSON.parse(window.sessionStorage.getItem('storage')));

  return async () => {
    const copy = { ...exams };
    dispatch(slice.actions.getExamsSuccess({ exams: {} }));
    dispatch(slice.actions.startLoading());

    try {
      const date1 = getDateTimeValue({ dateValue: filters.levyFrom, hourValue: filters.levyHourFrom });
      const date2 = getDateTimeValue({ dateValue: filters.levyTo, hourValue: filters.levyHourTo });
      const errors = validateDates({ start: date1, end: date2, startLabel: 'LEVY_START_DATE', endLabel: 'LEVY_END_DATE' });

      if (Object.keys(errors).length > 0)
        throw new Error('', { cause: [errors] });


      let examCodes;

      if (filters.examFilter) {
        examCodes = await getExamCode(filters.examFilter);
      }
      const response = await axios.post(API.path, {
        criteres: {
          ipp,
          ...filters,
          usercode,
          examFilter: filters.examFilter ? examCodes : [filters.examFilter],
          prelau: fDateTime(date2),
          preldu: fDateTime(date1),
          actorsSelected: actorsSelected.map(item => item.actorCode),
          prescrFilter: filters.prescrFilter?.map(item => item.actorCode),
          profile,
          allActorsSelected,
          allFavoriteActorsSelected
        },
        navig: {
          ...navig,
          nb_item_per_page: condensed ? 11 : 5
        },
        action: ACTIONS.LOADRESULTSCREEN
      });

      const { data } = response;
      if (data.statut === "OK") {
        dispatch(slice.actions.getExamsSuccess({ exams: data }));
        if (data.folders.length === 0) {
          throw new Error('NO_RESULTS');
        }
      } else if (data.statut === "NOK") {
        dispatch(slice.actions.getExamsSuccess({ exams: copy }));
        throw new Error(data.reason);
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error?.cause?.length > 0 ? error.cause[0] : error));
    }
  };
}

export function getExamsDemand({ ipp, demandeCode }) {
  const { exam: { filters, navig, condensed } } = store.getState();
  const { user: { usercode }, profile, allFavoriteActorsSelected, allActorsSelected, actorsSelected } = decrypt(JSON.parse(window.sessionStorage.getItem('storage')));

  return async () => {
    dispatch(slice.actions.startLoading());

    try {
      const date1 = getDateTimeValue({ dateValue: filters.levyFrom, hourValue: filters.levyHourFrom });
      const date2 = getDateTimeValue({ dateValue: filters.levyTo, hourValue: filters.levyHourTo });
      const errors = validateDates({ start: date1, end: date2, startLabel: 'LEVY_START_DATE', endLabel: 'LEVY_END_DATE' });

      if (Object.keys(errors).length > 0)
        throw new Error('', { cause: [errors] });


      let examCodes;

      if (filters.examFilter) {
        examCodes = await getExamCode(filters.examFilter);
      }
      const response = await axios.post(API.path, {
        criteres: {
          ipp,
          ...filters,
          usercode,
          examFilter: filters.examFilter ? examCodes : [filters.examFilter],
          prelau: fDateTime(filters.levyTo),
          preldu: fDateTime(filters.levyFrom),
          actorsSelected: actorsSelected.map(item => item.actorCode),
          prescrFilter: filters.prescrFilter?.map(item => item.actorCode),
          profile,
          demandecode: demandeCode,
          allActorsSelected,
          allFavoriteActorsSelected
        },
        navig: {
          ...navig,
          nb_item_per_page: condensed ? 11 : 5
        },
        action: ACTIONS.LOADRESULTSCREENATDEMAND
      });

      const { data } = response;
      if (data.statut === "OK") {
        dispatch(slice.actions.getExamsSuccess({ exams: data }));

        if (data.folders.length === 0) {
          throw new Error('NO_RESULTS');
        }
      } else {
        throw new Error('NO_RESULTS');
      }




    } catch (error) {

      dispatch(slice.actions.hasError(error?.cause?.length > 0 ? error.cause[0] : error));
    }
  };
}